import React, { Component } from 'react'
import { Dropdown } from 'react-bootstrap'
// import { Link } from 'react-router-dom'
// import { Trans } from 'react-i18next'

class Navbar extends Component {
  toggleOffcanvas() {
    document.querySelector('.sidebar-offcanvas').classList.toggle('active')
  }
  toggleRightSidebar() {
    document.querySelector('.right-sidebar').classList.toggle('open')
  }
  render() {
    return (
      <nav className="navbar p-0 fixed-top d-flex flex-row">
        <div className="navbar-menu-wrapper flex-grow d-flex align-items-stretch">
          <div className="navbar-brand-wrapper d-flex align-items-center justify-content-center">
            {/* <Link className="navbar-brand brand-logo-mini" to="/">
            <img
              src={require('../../assets/images/logo-mini.png')}
              alt="logo"
            />
          </Link> */}
            <button
              className="navbar-toggler navbar-toggler-right d-lg-none align-self-center"
              type="button"
              onClick={this.toggleOffcanvas}
            >
              <div
                aria-label="Hide Sidebar"
                className="app-sidebar__toggle"
                data-toggle="sidebar"
              ></div>
            </button>
            <a className="sidebar-brand brand-logo" href="index.html">
              <img
                src="/assets/images/brand/logo.png"
                alt="logo"
                style={{ width: 115, height: 'auto' }}
              />
            </a>
            <a className="sidebar-brand brand-logo-mini" href="index.html">
              <img
                src="/assets/images/brand/logo-1.png"
                alt="logo"
                style={{ width: 35, height: 'auto' }}
              />
            </a>
          </div>
          <button
            className="navbar-toggler align-self-center"
            type="button"
            onClick={() => document.body.classList.toggle('sidebar-icon-only')}
          >
            <div
              aria-label="Hide Sidebar"
              className="app-sidebar__toggle"
              data-toggle="sidebar"
            ></div>
          </button>
          <ul className="navbar-nav w-100">
            <li className="nav-item w-100"></li>
          </ul>
          <ul className="navbar-nav navbar-nav-right">
            <i
              className="fe fe-maximize-2 nav-item"
              style={{ marginRight: '15px', fontSize: '25px' }}
            ></i>
            <Dropdown alignRight as="li" className="nav-item">
              <Dropdown.Toggle
                as="a"
                className="nav-link count-indicator cursor-pointer"
              >
                <i className="fe fe-mail"></i>
                <span className="count">0</span>
              </Dropdown.Toggle>
              <Dropdown.Menu className="navbar-dropdown preview-list dropdown-menu-arrow">
                <h6 className="p-3 mb-0">Messages</h6>
                <Dropdown.Divider />
                <Dropdown.Divider />
                <a href="/">
                  <p className="p-3 mb-0 text-center text-white">
                    View All Support Messages
                  </p>
                </a>
              </Dropdown.Menu>
            </Dropdown>
            <Dropdown alignRight as="li" className="nav-item">
              <Dropdown.Toggle
                as="a"
                className="nav-link cursor-pointer no-caret"
              >
                <div className="navbar-profile">
                  <i
                    className="fe fe-align-right"
                    style={{
                      color: 'white',
                      fontSize: '15px',
                      marginTop: '-18px',
                    }}
                  ></i>
                </div>
              </Dropdown.Toggle>

              <Dropdown.Menu className="navbar-dropdown preview-list navbar-profile-dropdown-menu dropdown-menu-arrow">
                <Dropdown.Item
                  href="!#"
                  onClick={(evt) => evt.preventDefault()}
                  className="preview-item"
                >
                  <div className="preview-icon">
                    <i className="mdi mdi-account-outline text-white"></i>
                  </div>
                  <div className="preview-item-content">
                    <p className="preview-subject mb-1">My Profile</p>
                  </div>
                </Dropdown.Item>
                <Dropdown.Divider />
                <Dropdown.Item
                  href="!#"
                  onClick={(evt) => evt.preventDefault()}
                  className="preview-item"
                >
                  <div className="preview-icon">
                    <i className="mdi mdi-logout text-white"></i>
                  </div>
                  <div className="preview-item-content">
                    <p className="preview-subject mb-1">Log Out</p>
                  </div>
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </ul>
        </div>
      </nav>
    )
  }
}

export default Navbar
